import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=5b4d0210"
import script from "./tab-item.vue?vue&type=script&lang=js"
export * from "./tab-item.vue?vue&type=script&lang=js"
import style0 from "./tab-item.vue?vue&type=style&index=0&id=5b4d0210&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports